import React from 'react';

import FormikEditor from './FormikEditor';
import type { Props as EditorProps } from './FormikEditor';

type Props = {
  name: EditorProps['name'],
  language: EditorProps['language'],
  autoFocus?: boolean,
}

const FormikSignatureEditor: React.FC<Props> = ({ name, language, autoFocus = false }) => (
  <FormikEditor
    name={name}
    language={language}
    dataTest="mailing-signature-editor"
    id="mailing-signature-editor"
    editorHeight={150}
    maximumCharacterCount={10000}
    autoFocus={autoFocus}
  />
);

export default FormikSignatureEditor;
